module.exports = __webpack_public_path__ + "static/media/gallery16.f0dae86c.webp";